/**
 * Whether the user asked the OS to reduce animation.
 *
 * Read per call instead of cached: the preference can be toggled while the tab
 * is open, and every caller here is on a user-interaction path, not a hot loop.
 *
 * @returns {boolean}
 */
export const prefersReducedMotion = () => {
    return typeof window !== 'undefined'
        && typeof window.matchMedia === 'function'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
